"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeriodicReportType = void 0;
var PeriodicReportType;
(function (PeriodicReportType) {
    PeriodicReportType["INVENTORY_ADJUSTMENTS"] = "Inventory-Adjustments";
    PeriodicReportType["DESTRUCTIONS"] = "Destructions";
    PeriodicReportType["TRANSFER_IN"] = "Transfer-In";
    PeriodicReportType["TRANSFER_OUT"] = "Transfer-Out";
})(PeriodicReportType || (exports.PeriodicReportType = PeriodicReportType = {}));
//# sourceMappingURL=ONCompliancePeriodicModels.js.map